export const SUI_LOGIN_SCOPE = 'openid profile profile.write email phone blockchain.sui blockchain.sui.write blockchain.sui.zk'
